export const USE_MOCK_DATA = false;

export const mockUser = {
    token: "mock-auth-token-12345",
    username: "Test User",
    email: "test@example.com",
};

export const mockNotes = [
    {
        id: "1",
        title: "Project Alpha Ideas",
        content: JSON.stringify({
            blocks: [
                { text: "Ideas for Project Alpha:" },
                { text: "- Use React for frontend" },
                { text: "- Go for backend services" },
                { text: "- Graph database for connections" }
            ],
            entityMap: {}
        }),
        modified_at: new Date().toISOString()
    },
    {
        id: "2",
        title: "Meeting Notes: Team Sync",
        content: JSON.stringify({
            blocks: [
                { text: "Attendees: Alice, Bob, Charlie" },
                { text: "Action items:" },
                { text: "- Alice to check design" },
                { text: "- Bob to fix API bug" }
            ],
            entityMap: {}
        }),
        modified_at: new Date().toISOString()
    },
    {
        id: "3",
        title: "Research: Graph Algorithms",
        content: JSON.stringify({
            blocks: [
                { text: "Looking into PageRank and community detection." },
                { text: "Might be useful for ranking notes." }
            ],
            entityMap: {}
        }),
        modified_at: new Date().toISOString()
    }
];

export const mockGraphData = {
    nodes: [
        { entity_name: "Project Alpha", entity_type: "Project", label: "Project Alpha", id: "Project Alpha", description: "An early-stage initiative focused on shaping the core product experience." },
        { entity_name: "React", entity_type: "Technology", label: "React", id: "React", description: "Frontend framework powering the app UI and component system." },
        { entity_name: "Go", entity_type: "Technology", label: "Go", id: "Go", description: "Backend services language used for graph and note processing." },
        { entity_name: "Team Sync", entity_type: "Meeting", label: "Team Sync", id: "Team Sync", description: "Weekly alignment meeting covering priorities and blockers." },
        { entity_name: "Alice", entity_type: "Person", label: "Alice", id: "Alice", description: "Product lead coordinating design direction and roadmap." },
        { entity_name: "Bob", entity_type: "Person", label: "Bob", id: "Bob", description: "Engineer focused on API stability and graph infrastructure." },
        { entity_name: "Concept Mapping", entity_type: "Idea", label: "Concept Mapping", id: "Concept Mapping", description: "Visual practice to surface connections between notes." },
        { entity_name: "Graph UI", entity_type: "Project", label: "Graph UI", id: "Graph UI", description: "Interaction layer for exploring relationships between concepts." },
        { entity_name: "Design Sprint", entity_type: "Event", label: "Design Sprint", id: "Design Sprint", description: "Short workshop to validate product direction and prototypes." },
        { entity_name: "User Research", entity_type: "Project", label: "User Research", id: "User Research", description: "Ongoing interviews and discovery to inform roadmap." },
        { entity_name: "MVP Launch", entity_type: "Event", label: "MVP Launch", id: "MVP Launch", description: "Target milestone for the first public release." },
        { entity_name: "Tokyo", entity_type: "Place", label: "Tokyo", id: "Tokyo", description: "Location referenced in travel notes and planning." },
        { entity_name: "Marie Curie", entity_type: "Person", label: "Marie Curie", id: "Marie Curie", description: "Historical figure referenced in research notes." },
        { entity_name: "API Reliability", entity_type: "Idea", label: "API Reliability", id: "API Reliability", description: "Focus area for stabilizing backend integrations." },
        { entity_name: "Incident Review", entity_type: "Meeting", label: "Incident Review", id: "Incident Review", description: "Post-mortem meeting for outages and regressions." },
        { entity_name: "Feature Spec", entity_type: "Idea", label: "Feature Spec", id: "Feature Spec", description: "Written spec outlining scope and success criteria." },
        { entity_name: "Knowledge Graph", entity_type: "Idea", label: "Knowledge Graph", id: "Knowledge Graph", description: "Concept model connecting entities and notes." },
        { entity_name: "Mentorship", entity_type: "Idea", label: "Mentorship", id: "Mentorship", description: "Support network for team growth and onboarding." },
        { entity_name: "Design System", entity_type: "Project", label: "Design System", id: "Design System", description: "Reusable UI patterns and components." },
        { entity_name: "Onboarding", entity_type: "Project", label: "Onboarding", id: "Onboarding", description: "Experience for getting new users started." }
    ],
    edges: [
        { source: "Project Alpha", target: "React", label: "uses" },
        { source: "Project Alpha", target: "Go", label: "uses" },
        { source: "Team Sync", target: "Alice", label: "attended by" },
        { source: "Team Sync", target: "Bob", label: "attended by" },
        { source: "Project Alpha", target: "Graph UI", label: "includes" },
        { source: "Graph UI", target: "Concept Mapping", label: "visualizes" },
        { source: "Graph UI", target: "Design Sprint", label: "shaped by" },
        { source: "User Research", target: "Design Sprint", label: "feeds" },
        { source: "Project Alpha", target: "User Research", label: "informed by" },
        { source: "Project Alpha", target: "MVP Launch", label: "targets" },
        { source: "Alice", target: "Design Sprint", label: "leads" },
        { source: "Bob", target: "Graph UI", label: "builds" },
        { source: "Team Sync", target: "User Research", label: "updates" },
        { source: "Tokyo", target: "Project Alpha", label: "inspires" },
        { source: "Marie Curie", target: "Concept Mapping", label: "referenced in" },
        { source: "Bob", target: "API Reliability", label: "improves" },
        { source: "Bob", target: "Incident Review", label: "leads" },
        { source: "Bob", target: "Feature Spec", label: "reviews" },
        { source: "Bob", target: "Knowledge Graph", label: "implements" },
        { source: "Alice", target: "Design System", label: "owns" },
        { source: "Alice", target: "Onboarding", label: "drives" },
        { source: "Alice", target: "Mentorship", label: "supports" },
        { source: "Alice", target: "Feature Spec", label: "writes" },
        { source: "Alice", target: "Knowledge Graph", label: "prioritizes" }
    ]
};
